module.exports = __webpack_public_path__ + "static/media/pg18.f96a70c3.jpg";